var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"board-page--main"},[_c('header-general',{attrs:{"type":"board","page-title":_vm.pageTitle}}),_vm._t("default"),_c('footer-general',{staticClass:"footer-instance"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }